import moment from "moment";
import { insurancePolicyTypes } from "../../../ABLTC/SubComponents/SelectOptions";
import { AccountTypes } from "../../../../Common/Constant";
import { policyOwnerships } from "../Helpers/Constants";
import { SESSION_STORAGE_ABLTC_OBJECT_KEY, SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from "../../../../../sessionStorage";

const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
const isMSEnableRelationshipToOwner = accountObj && accountObj.msEnableRelationshipToOwner;

const handleCheckNull = (value) => {
    return value === null || value === undefined ? '' : value;
}

const getOwnerDetailsFromId = (value, ownerList) => {
    return ownerList !== undefined && ownerList.length !== 0 && ownerList.find(item => item.covrGeneratedID === value);
}

export const getInsuredPrefillData = (insuredData, fullForm) => {
    const insuredDetails = {
        proposedInsuredFirstName: handleCheckNull(insuredData.firstName),
        proposedInsuredMiddleInitial: handleCheckNull(insuredData.middleName),
        proposedInsuredLastName: handleCheckNull(insuredData.lastName),
        gender: handleCheckNull(insuredData.gender && insuredData.gender.trim()),
        birthdate: handleCheckNull(insuredData.dateOfBirth) === '' ? '' : moment(insuredData.dateOfBirth).format('MM/DD/YYYY'),
        state: handleCheckNull(insuredData.state),
        isOther: false,
        middleNameDisable: !!handleCheckNull(insuredData.middleName),
        ...(isMSEnableRelationshipToOwner && { insuredRelationshipWithOwner: fullForm && fullForm.pages && fullForm.pages.retrieveAccount.isProposedInsured ? 'Self' : '' }),
    }
    return insuredDetails;
}

const handleSetOtherOwnerInInsuredInfo = (index, fullFormState, insuredInfoDefaultState) => {
    return fullFormState.pages.insuredBasicInfo.insuredInfo[index] = insuredInfoDefaultState.insuredInfo[0];
}

export const getSortFieldName = (name) => {
    const sortName = name && name.split('.');
    return sortName.length >= 2 && sortName[1];
}

export const handleCheckDisableField = (fieldName, index, fullFormState) => {
    const ownerList = fullFormState.pages.retrieveAccount && fullFormState.pages.retrieveAccount.clientData && fullFormState.pages.retrieveAccount.clientData.owners;
    const combinedOwnerList = [...ownerList];
    const clientInfo = fullFormState.pages.retrieveAccount.clientData;
    (clientInfo.soleProprieter && clientInfo.soleProprieter.length > 0) && clientInfo.soleProprieter.forEach((element) => {
        combinedOwnerList.push(element);
    });
    const insuredId = fullFormState.pages.retrieveAccount.isProposedInsured === 'true' ? fullFormState.pages.retrieveAccount.owner : (index === 0 ? fullFormState.pages.retrieveAccount.insured : fullFormState.pages.retrieveAccount.secondInsured);
    const ownerDetails = getOwnerDetailsFromId(insuredId, combinedOwnerList);
    const insuredDetails = ownerDetails && getInsuredPrefillData(ownerDetails, fullFormState);
    const sortFieldname = getSortFieldName(fieldName);
    const matchedField = insuredDetails && insuredDetails[sortFieldname];
    return (matchedField && matchedField.trim() !== '');
}

export const PrefillABLTCInsuredInfo = (fullForm, clientData, formState, ownerList, insuredInfoDefaultState) => {
    const sessionData = getSessionStorageItem(SESSION_STORAGE_ABLTC_OBJECT_KEY);
    const sessionFormState = sessionData && sessionData.pages && sessionData.pages.retrieveAccount;
    const isPrefillBasedOnAccountType = [AccountTypes.INDIVIDUAL, AccountTypes.JOINT, AccountTypes.PARTNERSHIP, AccountTypes.UNINCORPORATED, AccountTypes.RPM].includes(clientData.accountType.toLowerCase());
    if (isPrefillBasedOnAccountType) {
        if (formState.insurancePolicyType === insurancePolicyTypes.INDIVIDUAL) {
            if (fullForm.pages.insuredBasicInfo.insuredInfo.length > 1) {
                fullForm.pages.insuredBasicInfo.insuredInfo.pop();
            }
            if (formState.isProposedInsured && (!sessionFormState || sessionFormState.isProposedInsured !== formState.isProposedInsured || sessionFormState.owner !== formState.owner)) {
                if (formState.isProposedInsured === 'false') {
                    handleSetOtherOwnerInInsuredInfo(0, fullForm, insuredInfoDefaultState);
                }
                if (formState.isProposedInsured === 'true') {
                    let insuredID = formState.owner;

                    if (clientData.accountType.toLowerCase() === AccountTypes.JOINT && formState.policyOwnership === policyOwnerships.JOINT) {
                        insuredID = formState.insured;
                    }
                    const selectedInsuredDetails = insuredID && getOwnerDetailsFromId(insuredID, ownerList);
                    const insuredDetails = selectedInsuredDetails && getInsuredPrefillData(selectedInsuredDetails, fullForm);
                    fullForm.pages.insuredBasicInfo.insuredInfo[0] = insuredDetails;
                }
            }
        }
        else if (formState.insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP) {
            if (fullForm.pages.insuredBasicInfo.insuredInfo.length <= 1) {
                fullForm.pages.insuredBasicInfo.insuredInfo.push(insuredInfoDefaultState.insuredInfo[0])
            }
            if (formState.insured && (!sessionFormState || sessionFormState.insured !== formState.insured)) {
                if (formState.insured !== 'Other') {
                    const firstInsuredDetails = getOwnerDetailsFromId(formState.insured, ownerList);
                    const insuredDetails = firstInsuredDetails && getInsuredPrefillData(firstInsuredDetails, fullForm);
                    fullForm.pages.insuredBasicInfo.insuredInfo[0] = insuredDetails;
                }
                else {
                    handleSetOtherOwnerInInsuredInfo(0, fullForm, insuredInfoDefaultState);
                }
            }
            if (formState.secondInsured && (!sessionFormState || sessionFormState.secondInsured !== formState.secondInsured)) {
                if (formState.secondInsured !== 'Other') {
                    const secondInsuredDetails = getOwnerDetailsFromId(formState.secondInsured, ownerList);
                    const insuredDetails = secondInsuredDetails && getInsuredPrefillData(secondInsuredDetails, fullForm);
                    fullForm.pages.insuredBasicInfo.insuredInfo[1] = insuredDetails;
                }
                else {
                    handleSetOtherOwnerInInsuredInfo(1, fullForm, insuredInfoDefaultState);
                }
            }
        }
    }
    else if (clientData.accountType.toLowerCase() === AccountTypes.TRUST || clientData.accountType.toLowerCase() === AccountTypes.LIMITED_LIABILITY) {
        if (formState.insurancePolicyType === insurancePolicyTypes.INDIVIDUAL) {
            if (fullForm.pages.insuredBasicInfo.insuredInfo.length > 1) {
                fullForm.pages.insuredBasicInfo.insuredInfo.pop();
            }
        }
        else if (formState.insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP) {
            if (fullForm.pages.insuredBasicInfo.insuredInfo.length <= 1) {
                fullForm.pages.insuredBasicInfo.insuredInfo.push(insuredInfoDefaultState.insuredInfo[0])
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/RetrieveAccount/SubComponents/PrefillABLTCInsuredInfo.js